import { render } from "./AirtableLogoIcon.vue?vue&type=template&id=07877aa8"
import script from "./AirtableLogoIcon.vue?vue&type=script&lang=js"
export * from "./AirtableLogoIcon.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/flydata-next/flydata-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__